import { v4 as uuidv4 } from "uuid";

import { useGetProgressGenerateAIJobSuggestion } from "./useGetProgressGenerateAIJobSuggestion";
import { formatDateToLocal } from "helpers/formatDateToLocal";
import { useAIProgressStore } from "store";

import { TGetProgressGenerateAIJobSuggestionRes } from "@type/api/businessUnit/types";

export const MAXIMUM_WAITING_TIME_IN_MINUTE = 6;

interface AIProgressDataWrapperProps {
  children: React.ReactNode;
}

const AIProgressDataWrapper = ({ children }: AIProgressDataWrapperProps) => {
  const onSetIsInProgress = useAIProgressStore(
    (state) => state.onSetIsInProgress
  );
  const onResetRefetchInterval = useAIProgressStore(
    (state) => state.onResetRefetchInterval
  );
  const onUpdateRefetchInterval = useAIProgressStore(
    (state) => state.onUpdateRefetchInterval
  );
  const onSetRefetchKey = useAIProgressStore((state) => state.onSetRefetchKey);

  useGetProgressGenerateAIJobSuggestion({
    onSuccess: (res) => {
      const isInProgress = validateInProgress(res);
      if (!isInProgress) {
        onResetRefetchInterval();
        onSetRefetchKey(uuidv4());
      } else {
        onUpdateRefetchInterval();
      }

      onSetIsInProgress(isInProgress);
    },
  });

  return <>{children}</>;
};

export default AIProgressDataWrapper;

const validateInProgress = (
  progress: TGetProgressGenerateAIJobSuggestionRes
) => {
  const createdAt = formatDateToLocal(progress.createdAt);
  const timeNow = new Date();
  const diffTime = Math.abs(timeNow.getTime() - (createdAt?.getTime() || 0));
  const diffMinute = Math.floor(diffTime / (1000 * 60)); // Hold time different in minute

  // If loading more than expected waiting time, set inprogress as false to avoid waiting too long
  if (diffMinute >= MAXIMUM_WAITING_TIME_IN_MINUTE) {
    return false;
  }

  const total = progress.total || 0;
  const processed = progress.processed || 0;
  const error = progress.error || 0;
  // if total equal with processed + error we can assume the process has finished
  if (total === processed + error) {
    return false;
  }

  return !!progress.isInProgress;
};
